<template>
  <v-container>
    <template v-if="loading">
      <div class="text-center">
        <v-progress-circular
          size="50"
          color="primary"
          indeterminate
        />
      </div>
    </template>

    <template v-else-if="order">
      <v-row
        v-if="!customer"
        align='center'
        justify='center'
      >
        <v-col cols='12' sm='8'>
          <CustomerForm :order="order"/>
        </v-col>
      </v-row>

      <v-row
        v-for='reservation in order.reservations'
        :key='reservation.id'
        align='center'
        justify='center'
      >
        <v-col cols='12' sm='8'>
          <ReservationCardFull
            :order="order"
            :reservation="reservation"
            :assigned="assigned"
            :redirected ="redirected"
          />
        </v-col>
      </v-row>
    </template>

    <template v-else>
      <div class="text-center">
        <v-btn
          x-large
          color='success'
          class='mr-2 mb-2'
          :to='{ name: "dashboard" }'
        >
          {{ $t('sidebar.dashboard') }}
        </v-btn>
      </div>
    </template>
  </v-container>
</template>

<script>
  import { mapState } from 'vuex'
  import { orderMixin } from '../../../mixins/order_mixin'
  import { orderCustomerMixin } from '../../../mixins/order_customer_mixin'
  import ReservationCardFull from '../../reservations/reservation_card_full'
  import CustomerForm from '../customer/customer_form'

  export default {
    name: 'OrderShow',
    components: {
      ReservationCardFull,
      CustomerForm,
    },
    mixins: [
      orderMixin,
      orderCustomerMixin,
    ],

    created() {
      this.$store.dispatch('order/fetchOrder', { id: this.$route.params.uuid })
        .then(order => {
          // Dopo aver recuperato l'order, se questo non ha un cliente, lo assegnamo. E' possibile farlo solo se
          // cercato tramite uuid. Se usato l'id, infatti, il backend lo cercherà tra gli ordini del cliente e non lo
          // troverà.
          //if (!order.customer_id) this.assign_order()
        }).catch(error => {
          console.log(`Cannot fetch order id ${this.$route.params.id}: ${error}`)
          this.$store.dispatch('layout/replaceAlert', {
            type: 'error',
            key: 'order_not_found'
          })
      })
    },

    // mounted() {
    //   // This ensures a single web socket connection. Call it in every component that wants to use Action Cable.
    //   // this.websocket = this.$cable.useGlobalConnection()
    //   this.$cable.subscribe({
    //     channel: 'GuestsChannel',
    //     room: 'public'
    //   })
    //
    //   // Or with an auth token: Calls your connectionUrl with a token GET-param, e.g. 'wss://www.your-app.de/cable?token=1290e42e42e5e1d68220d8de66092e75'
    //   // const token = this.$auth.getToken('local').replace('Bearer ', '')
    //   // this.websocket = this.$cable.useGlobalConnection(token)
    // },
    mounted(){
      this.redirected =  this.$route.query.redirect
    },
    data: () => {
      return {
        assigned: true,
        redirected: null
      }
    },

    computed: {
      ...mapState('layout', ['loading', 'submitting']),
    },

    methods: {
      /*assign_order: function() {
        this.$store.dispatch('order/assignOrder', this.order.uuid)
          .then(() => {
            this.assigned = true
            console.log(`Order ${this.order.code} successfully assigned`)
            // this.$router.push({ name: 'dashboard'})
            this.$store.dispatch('layout/addAlert', {
              type: 'success',
              key: 'order_assigned',
              i18n_attributes: { code: this.order.code }
            })
          })
          .catch(error => {
            this.assigned = false
            console.log(`Cannot assign order id ${this.order.id}: ${error}`)
            this.$store.dispatch('layout/replaceAlert', {
              type: 'error',
              key: 'order_unassigned'
            })
          })
      }*/
    },
  }
</script>
